import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";

import * as localizationActions from "../../Redux/Actions/localization";
import { toastMessage } from "../../utils/toast";
import { useTranslation } from "react-i18next";
import { getLocaleValue } from "../../utils";
import { onMessageListener } from "../../utils/pushNotification";
import { clearSession } from "../../utils/initiate";

function Landing({ history }) {

  const dispatch = useDispatch();
  const { i18n } = useTranslation();
  const [currentLanguage, setCurrentLanguage] = useState(
    localStorage.getItem("i18nextLng")
  );

  const changeLanguage = (value) => {
    i18n.changeLanguage(value);
    setCurrentLanguage(value);
  };

  onMessageListener().then(payload => {
    console.log(payload);
}).catch(err => console.log('failed: ', err));

  useEffect(() => {
    if (localStorage.getItem("localAr") === null) {
      //To Get English Localizations
      localizationActions
        .localization("EN")
        .then((res) => {
          if (res) {
            localStorage.setItem("localEn", JSON.stringify(res));
            changeLanguage("english");
          } else {
            localStorage.setItem("localEn", "");
            toastMessage(
              "error",
              (res && res.message) || `Unable to load the eng Localization`
            );
          }
        })
        .catch((err) => {
          err.response?.status === 401 && clearSession(dispatch, history);
        });
      //-----------------------------------------------------------------------------------------------------
      //To Get Arabic Localizations
      localizationActions
        .localization("AR")
        .then((res) => {
          if (res) {
            localStorage.setItem("localAr", JSON.stringify(res));
          } else {
            localStorage.setItem("localAr", "");
            toastMessage(
              "error",
              (res && res.message) || `Unable to load the ar Localization`
            );
          }
        })
        .catch((err) => {
          err.response?.status === 401 && clearSession(dispatch, history);
        });
    }
  }, []);

  return (
    <div className="account-body d-flex flex-column justify-content-center vw-100">
      <div
        className="logo logo-admin position-absolute"
        style={{ left: "60px", top: 0 }}
      >
        <img
          src="/Assets/aamer_logo.jpg"
          width="150px"
          height="auto"
          alt="logo"
          className="auth-logo"
        />
      </div>
      <div className="position-absolute" style={{ right: "10px", top: -40 }}>
        <div style={{ marginTop: "60px", marginRight: "60px" }}>
          <span
            style={{
              fontSize: "20px",
              color: "#b71c1c",
              cursor: "pointer",
              borderBottom: currentLanguage == "english" ? "2px solid" : "0px",
              fontWeight: "bold",
            }}
            onClick={() => {
              changeLanguage("english");
            }}
          >
            EN
          </span>
          <span
            style={{
              marginLeft: "10px",
              marginRight: "10px",
              fontSize: "20px",
              color: "#b71c1c",
              fontWeight: "bold",
            }}
          >
            |
          </span>
          <span
            style={{
              fontSize: "20px",
              color: "#b71c1c",
              cursor: "pointer",
              borderBottom: currentLanguage == "arabic" ? "2px solid" : "0px",
              fontWeight: "bold",
            }}
            onClick={() => {
              changeLanguage("arabic");
            }}
          >
            AR
          </span>
        </div>
      </div>

      <div className="container">
        <div className="row d-flex justify-content-center">
          <div className="col-12 align-self-center">
            <div className="row">
              <div className="d-flex justify-content-center">
                <div
                  className="c-pointer"
                  style={{ marginTop: "25px" }}
                  onClick={() => {
                    history.push("/login");
                  }}
                >
                  <img
                    src="/Assets/login.svg"
                    width="75px"
                    height="auto"
                    alt="login"
                    className="auth-logo"
                  />
                  <div
                    className="d-flex justify-content-center font-18"
                    style={{ marginTop: "20px" }}
                  >
                    <span style={{ margin: "0 auto", fontSize: "25px" }}>
                      {getLocaleValue("startup_login")}
                    </span>
                  </div>
                </div>

                {/* <img
                  src="/Assets/vertical_bar.svg"
                  style={{ marginLeft: "15px", marginTop: "35px" }}
                  width="5px"
                  height="50px"
                  alt="login"
                  className="auth-logo"
                />
                <div
                  className="c-pointer"
                  onClick={() => {
                    history.push("/register");
                  }}
                >
                  <img
                    src="/Assets/registerblue.png"
                    width="120px"
                    height="auto"
                    alt="register"
                    className="auth-logo"
                  />
                  <div className="d-flex justify-content-center font-18">
                    <span style={{ margin: "0 auto", fontSize: "25px" }}>
                      {getLocaleValue("startup_enroll")}
                    </span>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Landing;
